// https://vuex.vuejs.org/en/mutations.html
import {set} from '@/utils/vuex';

export default {
    onLanguageChanged(state, payload) {
        window.localStorage.setItem('vers-mdm-lang', payload.language);
        payload.$root.$i18n.locale = payload.language;
        state.language = payload.language;
        document.querySelector('html').setAttribute('lang', payload.language);
    },
    setOffline(state, isOffline) {
        state.isOffline = isOffline
    },
    setLogoutReason(state, logoutReason) {
        state.logoutReason = logoutReason;
    },
    setRoles(state, roles) {
        state.roles = roles;
    },
    logout(state) {
        state.authenticated = false;
        state.roles = [];
    },
    setUser: set('user'),
    setAuthenticated: set('authenticated'),
    setLoading: set('loading')
}
